import { Classes } from "@blueprintjs/core";
import { css } from "styled-components";

// Styles communs à tout conteneur qui héberge un <Drawer usePortal={false}>.
// `inner-hope-view` marque un drawer ouvert depuis un drawer déjà ouvert: il occupe
// toute la largeur de son parent au lieu des 42% du niveau 1.
export const drawerHostStyles = css`
  & .${Classes.OVERLAY}:has(> .inner-hope-view) {
    width: 100% !important;
  }

  & .${Classes.OVERLAY} {
    width: 42%;
    left: auto !important;
    /* Le contenu du drawer ne peut pas déborder de l'overlay. */
    overflow: hidden;

    @media (max-width: 1200px) {
      width: 58%;
    }
  }

  & .${Classes.DRAWER} {
    background: #f6f7f9 !important;
    /* Filet de sécurité: un panneau qui ne contraint pas sa hauteur reste atteignable. */
    overflow: auto;
  }
`;
